import React, { useState, useEffect } from 'react';
import axios from "axios";
import API_BASE_URL from "../config";
import PersonalInfoForm from '../component/PersonalInfoForm';
import EducationForm from '../component/EducationForm';
import UploadResume from '../component/User/UploadResume';
import '../css/multiStepForm.css';

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [sessionData, setSessionData] = useState({ user_id: "", job_id: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSessionData = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/get-user-and-job`, { withCredentials: true });
        setSessionData(res.data);
      } catch (err) {
        console.error('Error fetching session data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSessionData();
  }, []);

  if (loading || !sessionData.user_id || !sessionData.job_id) {
    return <div>Loading...</div>;
  }

  const handleNext = () => setStep(prev => prev + 1);
  const handleBack = () => setStep(prev => prev - 1);

  return (
    <div className="form-container">
      <div className="step-indicator">
        <div className={`step ${step === 1 ? 'active' : ''}`}>Personal info</div>
        <div className={`step ${step === 2 ? 'active' : ''}`}>Education and work</div>
        <div className={`step ${step === 3 ? 'active' : ''}`}>Submit</div>
      </div>

      {step === 1 && <PersonalInfoForm onNext={handleNext} />}
      {step === 2 && <EducationForm onBack={handleBack} onNext={handleNext} />}
      {step === 3 && <UploadResume />}
    </div>
  );
};

export default MultiStepForm;
